import { ResultStatus } from '@dispatch/shared/types';
import { DateField, Section, TextField } from '@dispatch/web/ui';
import { Box, Button, Grid, Stack, Toolbar } from '@mui/material';
import { isEmpty } from 'lodash';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

export type EditFieldCapacityOverrideProps = {
  control: Control<FieldValues>;
  errors: FieldErrors;
  onSubmit: () => void;
  upsertFieldCapacityOverrideStatus: ResultStatus;
  isEdit?: boolean;
};

export const EditFieldCapacityOverride = ({
  control,
  errors,
  onSubmit,
  upsertFieldCapacityOverrideStatus,
  isEdit,
}: EditFieldCapacityOverrideProps) => {
  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <Section>
        <Stack>
          <Grid container spacing={2} marginBottom={2} alignItems="end">
            <Grid size={6}>
              <DateField
                id="date"
                name="date"
                label="Date"
                control={control}
                errors={errors}
                required
                // The date is the override's key: changing it while editing
                // would silently create a second override rather than moving
                // the existing one, so it's locked once created.
                disabled={isEdit}
              />
            </Grid>
            <Grid size={6}>
              <TextField
                id="capacity"
                name="capacity"
                label="Capacity"
                type="number"
                control={control}
                defaultValue={0}
                error={errors?.['capacity']?.message}
              />
            </Grid>
          </Grid>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }} />
            <Box>
              <Button
                variant="contained"
                color="info"
                disabled={!isEmpty(errors)}
                sx={{
                  fontWeight: 700,
                  fontSize: '0.8125rem',
                  lineHeight: '22px',
                  color: 'white',
                  letterSpacing: '0.46px',
                }}
                onClick={onSubmit}
                data-testid={'edit-field-capacity-override-save'}
              >
                {upsertFieldCapacityOverrideStatus === 'loading'
                  ? 'Saving'
                  : 'Save'}
              </Button>
            </Box>
          </Toolbar>
        </Stack>
      </Section>
    </div>
  );
};
